// src/pages/LoginPage.js
'use client';
import { useState } from 'react';
import { Container, TextField, Button, Typography, Stack } from '@mui/material';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === 'universal' && password === 'Techlab123') {
      localStorage.setItem('isLoggedIn', 'true');
      onLogin();
    } else {
      setError('Sai username hoặc password');
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Typography variant="h5" align="center" gutterBottom>
        Webtool Login
      </Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
          <Button type="submit" variant="contained" fullWidth>
            Login
          </Button>
        </Stack>
      </form>
    </Container>
  );
}